import React from 'react';
// @ts-ignore
import NoSKill from '../../assets/img/NO_SKILL.svg';
import './no-skill-page.scss';

const NoSkillPage = () => {
    const baseClassName = 'no-skill-page';
    return (
        <div className={`${baseClassName}`}>
            <div className={`${baseClassName}__header`}>
                <div className={`${baseClassName}__header-icon`}>
                    <img
                        id="no-skill-page-logo"
                        src={NoSKill}
                        alt="no skill Logo"
                    />
                </div>
                <div className={`${baseClassName}__message`}>
                    <div className={`${baseClassName}__message-body`}>
                        No new clinical practice changes for the Skills you have
                        licensed. Check back soon for updates.
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NoSkillPage;
